<template>
  <div
    v-if="visibleBlocks.length"
    class="relative flex flex-col gap-8"
  >
    <h4 class="text-xl font-bold lg:text-center text-EXPONDO-black">
      {{ title }}
    </h4>
    <div
      class="flex flex-wrap justify-center gap-y-6 lg:gap-y-10 lg:w-9/12 lg:mx-auto
        max-lg:[&>*:nth-child(odd)]:pr-2 max-lg:[&>*:nth-child(even)]:pl-2"
    >
      <UspBlock
        v-for="block in visibleBlocks"
        :key="block.key"
        :icon-path="block.iconPath"
        :title="block.title"
        :is-horizontal="true"
      />
    </div>
  </div>
</template>

<script lang="ts">
import UspBlock from '~/components/molecules/UspBlock/UspBlock.vue';
import { filterUspBlocks } from '~~/helpers/cms/filterUspBlocks';
import type { UspBlock as UspBlockType } from '~~/types/cms/UspBlock';

export default defineComponent({
  name: 'UspSection',
  components: {
    UspBlock,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    blocks: {
      type: Array as PropType<UspBlockType[]>,
      required: true,
      validator: (uspItems: UspBlockType[]) => {

        return uspItems.every((block: UspBlockType) => {

          return block.iconPath && block.title;

        });

      },
    },
  },
  setup(props) {

    const { isExtraGuaranteeEnabled } = useStoreVsfExtended();
    const visibleBlocks = computed(() => filterUspBlocks(props.blocks, {
      isExtraGuaranteeEnabled: isExtraGuaranteeEnabled.value,
    }));

    return {
      visibleBlocks,
    };

  },
});
</script>
